import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../../chunks/tslib.es6.js";
import e from "../../core/Accessor.js";
import i from "../../core/Logger.js";
import { isNone as a } from "../../core/maybe.js";
import { createResolver as o } from "../../core/promiseUtils.js";
import { property as r } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as s } from "../../core/accessorSupport/decorators/subclass.js";
import { isDOMContainer as n } from "../DOMContainer.js";
import { ManipulatorCollection as l } from "./ManipulatorCollection.js";
var h = i.getLogger("esri.views.interactive.InteractiveToolBase");

var c = /*#__PURE__*/function (_e) {
  _inherits(c, _e);

  var _super = _createSuper(c);

  function c(t) {
    var _this;

    _classCallCheck(this, c);

    _this = _super.call(this, t), _this.toolState = "pending", _this.completed = !1, _this.manipulators = new l(), _this.updating = !1, _this.automaticManipulatorSelection = !0, _this._editableFlags = new Map([[1, !0], [0, !0]]), _this._creationStartedResolver = o(), _this._creationFinishedResolver = o();
    return _this;
  }

  _createClass(c, [{
    key: "active",
    get: function get() {
      return null != this.view && this.view.activeTool === this;
    }
  }, {
    key: "visible",
    set: function set(t) {
      this._set("visible", t), t || this.active && (this.view.activeTool = null), this.attached && (t ? this._show() : this._hide());
    }
  }, {
    key: "editable",
    get: function get() {
      return this.getEditableFlag(0);
    },
    set: function set(t) {
      this.setEditableFlag(0, t);
    }
  }, {
    key: "attached",
    get: function get() {
      return this._get("attached");
    }
  }, {
    key: "created",
    get: function get() {
      return "created" === this.toolState;
    }
  }, {
    key: "cursor",
    get: function get() {
      return null;
    }
  }, {
    key: "attach",
    value: function attach() {
      this.attached ? h.warn("Tool is already attached. Ignoring attach request.") : (this.manipulators.attach(), this.onAttach(), this.visible && this.onShow(), this._set("attached", !0));
    }
  }, {
    key: "detach",
    value: function detach() {
      this.attached ? (this.visible && this.onHide(), this.onDetach(), this.manipulators.detach(), this._set("attached", !1)) : h.error("Tool isn't currently attached. Ignoring detach request.");
    }
  }, {
    key: "activate",
    value: function activate() {
      a(this.view) ? h.error("Can't activate tool if view is not defined.") : this.active ? h.warn("Tool is already active, ignoring activation request.") : (n(this.view) && this.view.focus(), this.onActivate());
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      this.active ? this.onDeactivate() : h.warn("Tool is not active, ignoring deactivation request.");
    }
  }, {
    key: "handleInputEvent",
    value: function handleInputEvent(t) {
      this.attached ? this.onInputEvent(t) : h.warn("handleInputEvent() called on detached tool");
    }
  }, {
    key: "handleInputEventAfter",
    value: function handleInputEventAfter(t) {
      this.attached ? this.onInputEventAfter(t) : h.warn("handleInputEventAfter() called on detached tool");
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.manipulators.destroy(), this._set("view", null), this._set("completed", !1);
    }
  }, {
    key: "setEditableFlag",
    value: function setEditableFlag(t, e) {
      this._editableFlags.set(t, e), this.manipulators.isToolEditable = this.internallyEditable, this._updateManipulatorAttachment(), 0 === t && this.notifyChange("editable"), this.onEditableChange();
    }
  }, {
    key: "getEditableFlag",
    value: function getEditableFlag(t) {
      return this._editableFlags.get(t);
    }
  }, {
    key: "whenCreationStarted",
    value: function whenCreationStarted() {
      return this._creationStartedResolver.promise;
    }
  }, {
    key: "whenCreated",
    value: function whenCreated() {
      return this._creationFinishedResolver.promise;
    }
  }, {
    key: "rejectCreation",
    value: function rejectCreation(t) {
      "pending" !== this.toolState && "creating" !== this.toolState || this._creationStartedResolver.resolve(this), this._creationFinishedResolver.reject(t);
    }
  }, {
    key: "onActivate",
    value: function onActivate() {}
  }, {
    key: "onDeactivate",
    value: function onDeactivate() {}
  }, {
    key: "onAttach",
    value: function onAttach() {}
  }, {
    key: "onDetach",
    value: function onDetach() {}
  }, {
    key: "onShow",
    value: function onShow() {}
  }, {
    key: "onHide",
    value: function onHide() {}
  }, {
    key: "onEditableChange",
    value: function onEditableChange() {}
  }, {
    key: "onInputEvent",
    value: function onInputEvent(t) {}
  }, {
    key: "onInputEventAfter",
    value: function onInputEventAfter(t) {}
  }, {
    key: "internallyEditable",
    get: function get() {
      return this.getEditableFlag(0) && this.getEditableFlag(1);
    }
  }, {
    key: "startToolCreation",
    value: function startToolCreation() {
      if ("pending" === this.toolState) return this._creationStartedResolver.resolve(this), void (this.toolState = "creating");
      throw new Error("Unexpected tool state ".concat(this.toolState));
    }
  }, {
    key: "finishToolCreation",
    value: function finishToolCreation() {
      switch (this.toolState) {
        case "pending":
          this.startToolCreation();

        case "creating":
          this.created || this._creationFinishedResolver.resolve(this), this.toolState = "created";
          break;

        case "created":
          break;

        default:
          throw new Error("Unexpected tool state ".concat(this.toolState));
      }
    }
  }, {
    key: "complete",
    value: function complete() {
      this.finishToolCreation(), this._set("completed", !0);
    }
  }, {
    key: "_show",
    value: function _show() {
      this._updateManipulatorAttachment(), this.onShow();
    }
  }, {
    key: "_hide",
    value: function _hide() {
      this._updateManipulatorAttachment(), this.onHide();
    }
  }, {
    key: "_updateManipulatorAttachment",
    value: function _updateManipulatorAttachment() {
      this.attached && this.visible ? this.manipulators.attach() : this.manipulators.detach();
    }
  }]);

  return c;
}(e);

t([r()], c.prototype, "toolState", void 0), t([r({
  constructOnly: !0
})], c.prototype, "view", void 0), t([r({
  readOnly: !0
})], c.prototype, "active", null), t([r({
  value: !0
})], c.prototype, "visible", null), t([r({
  value: !0
})], c.prototype, "editable", null), t([r({
  value: !1,
  readOnly: !0
})], c.prototype, "attached", null), t([r({
  readOnly: !0
})], c.prototype, "created", null), t([r({
  readOnly: !0
})], c.prototype, "completed", void 0), t([r({
  readOnly: !0
})], c.prototype, "manipulators", void 0), t([r({
  readOnly: !0
})], c.prototype, "updating", void 0), t([r()], c.prototype, "cursor", null), t([r()], c.prototype, "automaticManipulatorSelection", void 0), c = t([s("esri.views.interactive.InteractiveToolBase")], c);
export { c as InteractiveToolBase };